/* ========================================================================
 * Apricot's Glyphs Module
 * ======================================================================== */


// json
import CBGlyphData from '../api/CBGlyph'

export default CBGlyphData
